import BaseService from "./BaseService";
import {
  CompanyQuestionnaireRequest,
  CompanyQuestionnaireResponse,
  CompanyQuestionnairesResponse
} from "./mappers/CompanyQuestionnaireMapper";

class CompanyQuestionnaireService extends BaseService {
  constructor() {
    super();
  }

  getCompanyQuestionnaire(companyId, questionnaireId) {
    return this.get(`companies/${companyId}/active-questionnaires/${questionnaireId}`).then((response) =>
      CompanyQuestionnaireResponse(response)
    );
  }

  updateCompanyQuestionnaire(companyId, questionnaireId, data) {
    return this.patch(
      `companies/${companyId}/active-questionnaires/${questionnaireId}/`,
      CompanyQuestionnaireRequest(data)
    ).then((response) => response.data);
  }

  getCompanyQuestionnairesByCompanyAndIsActive(companyId, search = "", ids = "", orderBy = null, desc = false) {
    let column = orderBy ? this.getOrderedColumnName(orderBy, desc) : null;
    let ordering = column ? `&ordering=${column}` : "";
    return this.get(`companies/${companyId}/active-questionnaires/?id=${ids}&is_active=true&search=${search}${ordering}/`).then((response) =>
      CompanyQuestionnairesResponse(response)
    );
  }

  getCompanyQuestionnairesByCompanyAndIsActiveAndType(companyId, type) {
    return this.get(
      `companies/${companyId}/active-questionnaires/?is_active=true&questionnaire__questionnaire_type=${type}`
    ).then((response) => CompanyQuestionnairesResponse(response));
  }

  activateCompanyQuestionnairesFromParent(companyId) {
    return this.post(`companies/${companyId}/copy_active_questionnaires_from_parent/`).then((response) => { })

  }
}

export default new CompanyQuestionnaireService();
